import axiosInstance from "../interceptor/interceptor"; // Assuming axiosInstance is correctly configured
import dictionary from "../dictionary";

const { auth } = dictionary;

const authServices = {
  sendUserOtp: (body: any) => axiosInstance.post(auth?.sendOtp(), body),
  reSendRegisterOtp: (body: any) =>
    axiosInstance.post(auth?.reSendRegisterOtp(), body),
  sendRegisterOtp: (body: any) =>
    axiosInstance.post(auth?.sendRegisterOtp(), body),
  /** Register user: send OTP. body: { firstName, lastName, key } (key = email or mobile) */
  authSendOtp: (body: { firstName: string; lastName: string; key: string }) =>
    axiosInstance.post(auth?.authSendOtp(), body),
  /** Register user: verify OTP. body: { key, otp } (key = email or mobile) */
  authVerifyOtp: (body: { key: string; otp: string }) =>
    axiosInstance.post(auth?.authVerifyOtp(), body),
  verifyUserOtp: (body: any) => axiosInstance.post(auth?.verifyOtp(), body),
  verifyRegisterOtp: (body: any) =>
    axiosInstance.post(auth?.verifyRegisterOtp(), body),
  signupOnboard: (body: any) => axiosInstance.post(auth?.signupOnboard(), body),
  setUserPassword: (body: any) => axiosInstance.post(auth?.setPassword(), body),
  userLogin: (body: any) => axiosInstance.post(auth?.customerLogin(), body),
  getLogin: (body: any) => axiosInstance.post(auth?.getLogin(), body),
  setLogin: (body: any) => axiosInstance.post(auth?.setLogin(), body),
  uploadImage: (body: any) => axiosInstance.put(auth?.uploadImage(), body),
  registerNewUser: (body: any) => axiosInstance.post(auth?.registerNewUser(), body),
  sendCoApplicantOtp: (body: any) => axiosInstance.post(auth?.sendCoApplicantOtp(), body),
  verifyCoApplicantOtp: (body: any) => axiosInstance.post(auth?.verifyCoApplicantOtp(), body),
  bypassLogin: (body: any) => axiosInstance.post(auth?.bypassLogin(), body),
  userLogout: () => axiosInstance.post(auth?.logout()),
};

export default authServices;
